var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2057 3.00457C6.46989 3.44222 2.89206 7.48905 3.03813 12.2428C3.1842 16.9965 7.00373 20.8161 11.7575 20.9621C16.5112 21.1082 20.5581 17.5304 20.9957 12.7946C21.0752 11.9344 20.1002 11.3849 19.4055 11.8984C17.3268 13.4349 14.4366 13.2194 12.6087 11.3915C10.7809 9.56364 10.5653 6.67351 12.1019 4.59473C12.6153 3.90009 12.0658 2.92508 11.2057 3.00457ZM9.43194 5.46733L9.40713 5.54366C8.62485 8.04736 9.24997 10.8612 11.1945 12.8057L11.3918 12.9958C13.3263 14.7904 16.0364 15.3493 18.4566 14.5931L18.5319 14.5673L18.4989 14.6541C17.4111 17.272 14.7929 19.0545 11.8189 18.9631C8.12154 18.8495 5.15079 15.8787 5.03719 12.1814C4.94581 9.20741 6.7283 6.58917 9.34612 5.50134L9.43194 5.46733Z",
    fill: "#2A90FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.6e620e85.svg";
export { ForwardRef as ReactComponent };